import React from "react";
import styled from "styled-components";
import _ from "lodash";

const PeopleCard = ({ url, name, position, contentList }) => {
  return (
    <Wrapper>
      <img src={url} alt="" />
      <div className="info">
        <span className="name">{name}</span>
        <span className="position">{position}</span>
      </div>
      {_.map(contentList, (item, index) => (
        <div className="content" key={index}>
          {item}
        </div>
      ))}
    </Wrapper>
  );
};

export default PeopleCard;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 260px;
  height: 414px;
  background: #ffffff;
  box-shadow: 0px 2px 11px 0px rgba(101, 43, 0, 0.08);
  border-radius: 13px;
  > img {
    width: 100%;
  }
  > .info {
    margin: 14px 0 8px 0;
    > .name {
      margin-right: 3px;
      font-weight: 500;
      font-size: 17px;
      vertical-align: bottom;
      color: #2c2e34;
      line-height: 24px;
    }
    > .position {
      font-weight: 400;
      font-size: 13px;
      vertical-align: bottom;
      color: #4b4f5a;
      line-height: 18px;
    }
  }
  > .content {
    font-weight: 400;
    font-size: 13px;
    color: #4b4f5a;
    line-height: 23px;
  }
`;
